// src/socket.js
import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/$/, "")
  : (window.location.hostname === "localhost"
      ? "http://localhost:3005"
      : `http://${window.location.hostname}:3005`);

export const socket = io(SOCKET_URL, {
  transports: ["websocket"],
});
